export class AssociationFrontPageClaims {
    public claim?: string;
    public subclaim?: string;
    public metaClaim?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
